import { render, staticRenderFns } from "./FlexibleCopSavingsWidget.vue?vue&type=template&id=51b1c954&scoped=true&"
import script from "./FlexibleCopSavingsWidget.vue?vue&type=script&lang=js&"
export * from "./FlexibleCopSavingsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b1c954",
  null
  
)

export default component.exports